import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import "./App.css";
import DropdownServices from "./services/v1/dropdownServices";
import MaintenancePage from "./components/maintenance/MaintenancePage";
import Packages from "./components/packagesPage/index";
import Checkout from "./components/checkoutPage/index";
import OrderPay from "./components/confirmation/orderPay";
import Login from "./components/login/index";
import UserDashboard from "./components/userDashboard/index";
import AdminDashboard from "./components/adminDashboard/index";
import SponsorConfirmation from "./components/confirmation/sponsorConfirmation";
import { SnackbarProvider } from "./ui-components/snackbarProvider";
import { AuthProvider } from "./authentication/authContext";
import ProtectedRoute from "./authentication/protectedRoutes";
import PayLaterConfirmation from "./components/confirmation/paylaterConfirmation";
import OrderEdit from "./components/confirmation/OrderEdit";
import SelfServiceEdit from "./components/selfService/SelfServiceEdit";

function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const [checkingMaintenance, setCheckingMaintenance] = useState(true);
  const [inMaintenance, setInMaintenance] = useState(false);

  useEffect(() => {
    let cancelled = false;

    DropdownServices.maintenanceStatus()
      .then((res) => {
        if (!cancelled) setInMaintenance(Boolean(res?.data?.in_maintenance));
      })
      .catch((err) => {
        // Fail open -- a transient error here shouldn't block real donors.
        console.error("Error checking maintenance status:", err);
      })
      .finally(() => {
        if (!cancelled) setCheckingMaintenance(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  if (checkingMaintenance) {
    return null;
  }

  if (inMaintenance) {
    return <MaintenancePage />;
  }

  return (
    <AuthProvider>
      <SnackbarProvider maxSnack={3}>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Packages />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/order-pay" element={<OrderPay />} />
          <Route path="/order-edit" element={<OrderEdit/>}/>
          <Route path="/manage-reservation" element={<SelfServiceEdit />} />
          <Route path="/change-date" element={<Navigate to="/" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/user-dashboard" element={<UserDashboard />} />
          <Route
            path="/admin-dashboard"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route path="/confirmation" element={<SponsorConfirmation />} />
          <Route
            path="/paylater-confirmation"
            element={<PayLaterConfirmation />}
          />
        </Routes>
      </SnackbarProvider>
    </AuthProvider>
  );
}

export default App;
